module.exports = __webpack_public_path__ + "media/images/front/common/no_image_doctor_2x-86c3a5e2ad364c33ba48941f35191765.png";